import { AdminApi } from 'stylemix-vue-admin'

export default class CommissionsApi extends AdminApi {
  constructor(parameters) {
    super('partners/commissions', parameters)
  }

  process(ids, partner_id, param, config = {}) {
    return this.submit(
      'post',
      `/${this.endpoint}/process`,
      { ids: ids || [], partner_id },
      config,
    )
  }
}
